// extracted by mini-css-extract-plugin
module.exports = {"app__header":"L_c5","app__footer":"L_bb","app__flex_row":"L_c6","app__content__list":"L_c7"};